import React, { FC, ReactNode } from 'react';
import { FeatureIcon } from './FeatureIcon';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  onLearnMore?: () => void;
}

export const FeatureCard: FC<FeatureCardProps> = ({ icon, title, description, onLearnMore }) => {
  return (
    <div
      className="
        w-[384px] h-[262px]
        rounded-[16px]
        border border-solid border-gray-200
        bg-white
        py-[32px]
        px-[12px]
        flex flex-col
        items-center
        text-center
        gap-[10px]
      ">
      {/* ICON */}
      <FeatureIcon>{icon}</FeatureIcon>

      {/* TITLE + DESCRIPTION */}
      <div className="flex flex-col items-center gap-[20px]">
        <span
          className="
            text-[20px]
            leading-[30px]
            font-600
            text-gray-900
          ">
          {title}
        </span>

        <p
          className="
          m-0
            text-[16px]
            leading-[24px]
            text-[#667085]
          ">
          {description}
        </p>
      </div>

      {/* CTA */}
      <Button type={'text'} onClick={onLearnMore}>
        <div className="flex items-center gap-[8px] text-ai-purple font-600">
          <div>Learn more</div>
          <ArrowRightOutlined />
        </div>
      </Button>
    </div>
  );
};
